import { useEffect } from 'react';
import RouterComponent from './routes';
import GlobalStyles, { font } from '@/modules/defines/styles';
import { UserAgent } from '@/utils/userAgent';
import { ThemeProvider } from 'styled-components';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AmplitudeClient from './components/common/AmplitudeClient';

function App() {
  const { os } = UserAgent;
  const queryClient = new QueryClient();

  // 브라우저 환경에서만 실행
  const isTablet = () => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return false;
    }

    const userAgent = navigator.userAgent;

    if (
      /iPad/.test(userAgent) ||
      (/Macintosh/.test(userAgent) && 'ontouchend' in document)
    ) {
      return true;
    }

    if (/Android/.test(userAgent) && !/Mobile/.test(userAgent)) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (os.isIos || os.isAndroid) {
        if (isTablet()) {
          document.body.classList.add('isTablet');
        } else {
          document.body.classList.add('isMobile');
        }
      } else {
        document.body.classList.add('isDesktop');
      }
    }
  }, [os]);

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <GlobalStyles />
        <AmplitudeClient />
        <ThemeProvider theme={{ font }}>
          <RouterComponent />
        </ThemeProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
